import {
    isHeightLG,
    isHeightXL,
    isHeightXXL,
    isWidthSM,
    isWidthMD,
    isWidthLG,
    isWidthXL,
} from '../../reducers/app'
import { useAppSelector } from '../../reducers'

interface UseSize {
    size: {
        height: {
            isLG: boolean;
            isXL: boolean;
            isXXL: boolean;
        };
        width: {
            isSM: boolean;
            isMD: boolean;
            isLG: boolean;
            isXL: boolean;
        };
    };
    isDesktop: boolean;
    isMobile: boolean;
}

function useSize(): UseSize {
    const window = useAppSelector((state) => state.app.window)
    const isLG = isWidthLG(window)

    return {
        size: {
            height: {
                isLG: isHeightLG(window),
                isXL: isHeightXL(window),
                isXXL: isHeightXXL(window),
            },
            width: {
                isSM: isWidthSM(window),
                isMD: isWidthMD(window),
                isLG,
                isXL: isWidthXL(window),
            },
        },
        isDesktop: isLG,
        isMobile: !isLG,
    }
}

export default useSize
